// Generated from App.tsx for a single page build. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ResourcesPage from "../pages/Resources/Resources";
const __wvcRoutePaths = ["/ResourcesPage"];
function AppRoutes() {
  const location = useLocation();
  return <Routes key={location.pathname}>
            
            
            
            
            
            
            
            <Route path={__wvcRoutePaths[0]} element={<ResourcesPage />} />
            
            
            
            
            
            </Routes>;
}
function App() {
  return <>
            <div className="app">
                <AppRoutes />
            </div>
        </>;
}
export default App;
